import { FC, ReactNode } from 'react'
import Caret from 'src/Icon/Caret'

const buttonStyles = {
  filter:
    'text-black border border-borderGrey bg-white hover:bg-secondaryGrey active:bg-clickGrey rounded-3xl',
  filterSelect:
    'text-primaryBlue border border-primaryBlue bg-white hover:bg-secondaryGrey active:bg-clickGrey rounded-3xl',
  tag: 'text-tagBlue bg-fillBlue hover:bg-hoverBlue active:bg-clickBlue rounded-md pr-1 pl-2',
  emptyTag: 'text-black bg-secondaryGrey hover:bg-hoverBlue active:bg-clickBlue rounded-md pr-1 pl-2',
  input: 'h-8 text-black border border-borderGrey bg-white rounded-xl',
}

type DropdownButtonProps = {
  onClick?: () => void
  children: ReactNode
  styles?: string
  ariaLabel: string
  type?: 'tag' | 'filter' | 'filterSelect' | 'input' | 'emptyTag'
  disabled?: boolean
}

const DropdownButton: FC<DropdownButtonProps> = ({
  onClick,
  children,
  ariaLabel,
  type = 'filter',
  disabled = false,
  styles,
}) => {
  return (
    <button
      aria-label={ariaLabel}
      className={`gap-x-1.5 flex py-0.5 pl-3 pr-2 ${buttonStyles[type]} ${
        disabled ? 'cursor-not-allowed' : ''
      } ${styles ? styles : ''}`}
      onClick={onClick}
      disabled={disabled}
      type="button"
    >
      {children}
      <Caret />
    </button>
  )
}

export default DropdownButton
